import request from '@/utils/request'
import qs from 'qs'
import store from '@/store/index'
import {userInfoBaseURL} from '@/config/net.config.js'

/**
 *  查询待办事项
 * @param {*} data 
 * @returns 
 */
 export function queryWaitingRun(state,pageIndex,pageSize,f1) {
  return request({
    url: '/api/wtbuService/queryRunByRunState?runState='+state+'&f1='+f1+'&pageIndex='+pageIndex+'&pageSize='+pageSize,
    head: 'application/json;charset=UTF-8',
    method: 'get',
  })
}

/**
 *  查询我的服务事项
 * @param {*} data 
 * @returns 
 */
export function queryMyHomePageStat(data) {
  return request({
    url: '/api/wtbuService/queryMyHomePageStat',
    data,
    head: 'application/json;charset=UTF-8',
    method: 'get',
  })
}

/**
 *  查询我的服务办理情况
 * @param {*} data
 * @returns 
 */
export function queryServiceRun(data) {
  return request({
    url: '/api/wtbuService/queryRun',
    data,
    head: 'application/json;charset=UTF-8',
    method: 'post',
  })
}
/**
 *  查询OA待办
 * @param {*} data
 * @returns 
 */
 export function queryPending(data) {
  return request({
    url: '/api/oa/pending',
    data,
    head: 'application/json;charset=UTF-8',
    method: 'post',
  })
}
/**
 *  查询OA数据添加到serviceRun表中
 * @param {*} data
 * @returns 
 */
 export function getOA(loginName) {
  return request({
    url: '/api/oa/getOA?loginName='+loginName,
    method: 'GET',
  })
}
/**
 *  查询OA已发
 * @param {*} data
 * @returns 
 */
 export function querySend(data) {
  return request({
    url: '/api/oa/send',
    data,
    head: 'application/json;charset=UTF-8',
    method: 'post',
  })
}
/**
 *  查询OA已办
 * @param {*} data
 * @returns 
 */
 export function queryDone(data) {
  return request({
    url: '/api/oa/done',
    data,
    head: 'application/json;charset=UTF-8',
    method: 'post',
  })
}
/**
 * 查询我的收藏
 * @param {*} data 
 * @returns 
 */
export function queryMyFollow() {
  return request({
    url: '/api/wtbuService/queryMyFollow',
    head: 'application/json;charset=UTF-8',
    method: 'get',
  })
}

/**
 * 评分
 * @param {*} data 
 * @returns 
 */
 export function commitServiceEval(data) {
  return request({
    url: '/api/wtbuService/commitServiceEval',
    data,
    head: 'application/json;charset=UTF-8',
    method: 'post',
  })
}

/**
 * 修改评分状态
 * @param {*} data 
 * @returns 
 */
export function updateServiceRun(data) {
  return request({
    url: '/api/wtbuService/updateServiceRun',
    data,
    head: 'application/json;charset=UTF-8',
    method: 'post',
  })
}
/**
 * 查询用户信息
 * @param {*} id 
 * @returns 
 */
export function queryUserInfoByUserid(id) { 
  return request({
    url:userInfoBaseURL + '/api/user/getUserInfoByUserid?userid=' + id,
    head: 'application/json;charset=UTF-8',
    method: 'get',
    token:localStorage.getItem('userInfoToken'),
  })
}

// 查询消息
export function getUserMsg(data) {  
  console.log(data)
  return request({
    url: userInfoBaseURL + '/api/user/getUserMsg?'+qs.stringify(data),
    head: 'application/json;charset=UTF-8',
    method: 'get',
    token:store.getters.getUserInfoStorage,
  })
}
